module.exports = __webpack_public_path__ + "img/chart-tree-map.bb098c1b.svg";